import { Grid, LinearProgress, Paper } from "@material-ui/core";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";

const MercatorioAnalysis = () => {
  const [state, setState] = useState({
    loading: true,
    qty: {
      series: [],
      options: {
        chart: {
          toolbar: false,
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: { colors: ["#000"] },
        },
        title: {
          text: "Quantidade de precatórios / tribunal",
          floating: true,
          align: "top",
          style: {
            color: "#000",
            fontFamily:
              "'Hind Vadodara', sans-serif, 'Open Sans', Arial, Helvetica, Sans-Serif",
            fontWeight: "400",
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              position: "top",
            },
          },
          labels: [],
        },
      },
    },
  });

  useEffect(() => {
    axios
      .request({
        method: "GET",
        url: "/v1/precatorio_analysis",
      })
      .then((response) => {
        const { data } = response;

        setState({
          loading: false,
          qty: {
            ...state.qty,
            series: [
              {
                name: "Quantidade de precatórios / tribunal",
                data: Object.values(data.qty),
              },
            ],
            options: {
              ...state.qty.options,
              labels: Object.keys(data.qty),
            },
          },
        });
      })
      .catch(() => {
        alert(
          "Não conseguimos fazer a solicitação para os dados de análise. Tente novamente mais tarde"
        );
      });
  }, []);

  return (
    <div className="analysis-area">
      <Grid item sm={12} md={8}>
        <Paper>
          {state.loading ? (
            <LinearProgress />
          ) : (
            <Chart
              options={state.qty.options}
              series={state.qty.series}
              type="bar"
            />
          )}
        </Paper>
      </Grid>
    </div>
  );
};

export default MercatorioAnalysis;
